import { GAME_ID } from '../../data/constants';

const initState = {
  paperOrder: [],
};

const BackgroundPaperReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }
  switch (type) {
    case 'LOAD_NEW_LEVEL':
      // payload should be a shuffled array of all background paper indeces, the index will be standard item index.
      // if ITEMS_IN_ROUND ever is above the number of background images available, we would need a separate index here
      return {
        ...state,
        paperOrder: payload.paperOrder,
      };
    case 'SET_ONLY_DOING_ONBOARDING':
      return {
        ...state,
        paperOrder: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      };
    default:
      return state;
  }
};

export default BackgroundPaperReducer;
